<template>
  <div id="app">
    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="region">
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择身份"
            style="width: 100%"
          >
            <el-option label="学校管理员" value="school"></el-option>
            <el-option label="老师" value="teacher"></el-option>
            <!-- <el-option label="学生" value="student"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="input">
          <el-input
            v-model="ruleForm.input"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 100%"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-container>
      <div class="feis" v-if="$route.path != '/live'">
        <el-header>
          <el-row>
            <el-col :span="20">
              <el-col :span="10">
                <el-image
                  style="margin-top: 5px; width: 150px; float: left"
                  :src="schoolLogo"
                  fit="contain"
                ></el-image>
                <!-- <el-image style="margin-bottom: 5px;margin-left:10px;" :src="schoolLogo1" fit="contain"></el-image> -->
                <!-- <div class="zhiboketang">直播课堂</div> -->
              </el-col>
              <el-col :span="14">
                <el-menu
                  background-color="#fff"
                  active-text-color="#dd6058"
                  text-color="#333"
                  :default-active="$route.path"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                >
                  <el-menu-item
                    :index="list.html"
                    v-for="list in html"
                    @click="clickMenu(list.id)"
                    :key="list.id"
                    >{{ list.name }}</el-menu-item
                  >
                </el-menu>
              </el-col>
            </el-col>
            <el-col :span="4" style="line-height: 60px; text-align: right">
              <el-popover
                placement="bottom"
                title=""
                width="100"
                trigger="hover"
              >
                <el-button @click="tui" size="small" style="margin: 0 35px"
                  >退出登录</el-button
                >
                <span slot="reference" style="cursor: pointer">{{
                  names
                }}</span>
              </el-popover>
              <span class="deng" v-show="!denlu" @click="dialogVisible = true"
                >登录</span
              >
            </el-col>
          </el-row>
        </el-header>
      </div>
      <el-container :class="{app_container:$route.path != '/live' && $route.path != '/liveList'}" style="background-color: #fafafa;">
        <el-main
          v-if="$route.path != '/live' && $route.path != '/liveList'"
          style="
            margin: 0px auto;
            max-width: 1440px;
            min-height: 700px;
            box-shadow: 0px 0px 5px 2px rgba(72, 72, 72, 0.05);
          "
        >
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"> </router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
          <!-- <div style="height: 150px;"></div> -->
        </el-main>
        <el-main :class="{live_main:$route.path == '/live'}" v-else>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"> </router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
          <!-- <div style="height: 150px;"></div> -->
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {
  bookget,
  preparebook,
  coursevolumelist,
  courseversionlist,
  UsercenterGetInfo,
  MenuTreeByUser,
  UserLogout,
  usercenterinfo,
  schoolgetinfo,
  menutreeuser,
  subjeclist,
  userlogin,
} from "@/api/home";
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        name: "",
        region: "teacher",
        input: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写账号",
            trigger: "blur",
          },
        ],
        input: [
          {
            required: true,
            message: "请填写密码",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change",
          },
        ],
      },
      show: false,
      activeIndex: "0",
      erji: [],
      names: "",
      schoolname: "",
      schoolLogo: require("./assets/img/Logo3.png"),
      html: "",
      index: "",
      shouw: false,
      loading: false,
      subjec: [],
      subjecid: "",
      version: [],
      versionid: "",
      volume: [],
      volumeid: "",
      gradeId: "",
      slhuif: false,
      denlu: "",
    };
  },
  watch: {},
  methods: {
    clickMenu(index) {
      // if (index == "134") {
      //   this.$message({
      //     message: "暂未开放。。。",
      //     type: "warning",
      //   });
      //   this.$router.push("/zplay");
      // }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          that.loading = true;
          // let params = {
          //   roleType: that.ruleForm.region || localStorage.getItem(roleType),
          //   account: that.ruleForm.name || localStorage.getItem(account),
          //   password: that.ruleForm.input || localStorage.getItem(password)
          // };
          let params = {
            roleType: that.ruleForm.region,
            account: that.ruleForm.name,
            password: that.ruleForm.input,
          };
          userlogin(params)
            .then((res) => {
              that.loading = false;
              if (res.data.code == "0") {
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem("roleType", that.ruleForm.region);
                that.dialogVisible = false;
                // this.$router.go(0);
                location.reload();
                that.usercentergetinfo();
              } else {
                that.$message(res.data.msg);
              }
            })
            .catch(() => {
              that.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    UsercenterGetInfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.removeItem("date");
          localStorage.setItem("roleType", res.data.data.roleType);
          if (res.data.data.roleType == "student") {
            that.names = res.data.data.student.name;
            that.schoolname = res.data.data.student.schoolName;
            localStorage.setItem("userId", res.data.data.userId);
            localStorage.setItem("schoolId", res.data.data.student.schoolId);
            that.schoolgetinfo(res.data.data.student.schoolId);
            localStorage.setItem(
              "classesId",
              res.data.data.student.gradeClassesInfo.classesId
            );
            localStorage.setItem("rosterNo", res.data.data.student.rosterNo);
          } else if (res.data.data.roleType == "teacher") {
            localStorage.setItem("teacherId", res.data.data.teacher.id);
            that.names = res.data.data.teacher.name;
            that.schoolname = res.data.data.teacher.schoolName;
            localStorage.setItem("schoolId", res.data.data.teacher.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
            that.shouw = true;
          } else {
            that.shouw = true;
            that.slhuif = true;
            that.names = res.data.data.school.name;
            that.schoolname = res.data.data.school.name;
            localStorage.setItem("schoolId", res.data.data.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
          }
          localStorage.setItem("userName", that.names);
          localStorage.setItem("userId", res.data.data.userId);
          this.menutreeuser();
        })

        .catch(() => {});
    },
    tui() {
      let that = this;
      UserLogout()
        .then((res) => {
          localStorage.clear();
          this.$router.go(0);
          setTimeout(() => {
            this.denlu = localStorage.getItem("token");
          }, 200);
          //   window.location.href = "http://www.welaiedu.cn/#/studyindex";
        })
        .catch(() => {});
    },
    schoolgetinfo(s) {
      let that = this;
      let params = {
        id: s,
      };
      schoolgetinfo(params)
        .then((res) => {
          //					that.schoolLogo = res.data.data.schoolLogo
           localStorage.setItem("groupId", res.data.data.groupId);
        })
        .catch(() => {});
    },
    menutreeuser() {
      let that = this;
      let params = {
        appCode: "YOUKE",
        parentId: 0,
      };
      menutreeuser(params)
        .then((res) => {
          if (!res) {
            // localStorage.clear();
            return false;
          }
          that.html = res.data.data;
          if (this.$route.path == "" || this.$route.path == "/") {
            that.$router.push({
              path: that.html[0].html,
            });
          }
        })
        .catch(() => {});
    },
    handleSelect(s) {
      this.$router.push({
        path: s,
      });
    },
  },
  components: {
    // 声明子组件名字
  },
  created() {},
  mounted() {
    let that = this;
    // 从地址栏获取token
    let qtokens = this.$route.query.token;
    if (qtokens !== undefined && qtokens !== null) {
      localStorage.setItem("token", qtokens);
    }
    let qtoken = localStorage.getItem("token");
    if (qtoken !== undefined && qtoken !== null) {
      this.UsercenterGetInfo();
      this.menutreeuser();
    } else {
      if (qtokens) {
        setTimeout(() => {
          this.UsercenterGetInfo();
          this.menutreeuser();
        }, 500);
      }
      setTimeout(() => {
        this.UsercenterGetInfo();
        this.menutreeuser();
      }, 500);
    }

    let path = this.$route.path;
    if (path == "/") {
      that.$router.push("/liveList");
    }
    this.denlu = localStorage.getItem("token");
  },
};
</script>

<style>
.deng {
  cursor: pointer;
  color: #fff;
  background-color: #dd6058;
  padding: 5px 20px;
  border-radius: 50px;
  text-align: center;
}
.app_container {
  margin-top: 70px !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue